import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { dataGridStyle } from "../../../theme";
import { useEffect, useState } from "react";
import API from "../../../api";

const LicenseExpT = () => {
  const [customers, setCustomers] = useState([]);
  const [charged, setCharged] = useState(false)


  useEffect(() => {
    API.getCustomers({ expire: true })
      .then((result) => {
        // Filtra i dati per ottenere solo le righe con giorniRimanenti < 30
        const filteredData = result.data
          .filter((item) => item.giorniRimanenti < 100)
          .map((item) => ({
            id: item.matricola,
            ...item,
          }));
        setCustomers(filteredData);
        setCharged(true)
      })
      .catch((error) => {
        console.error(
          "[LicenseExpT] Si è verificato un errore durante il recupero dei dati:",
          error
        );
        setCharged(true)
      });
  }, []);

  const columns = [
    {
      field: "ragioneSociale",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "matricola",
      headerName: "SERIAL NUMBER",
      minWidth: 100,
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "giorniRimanenti",
      headerName: "License Days Left",
      minWidth: 120,
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 350,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <a href={`mailto:${params.value}`} style={{ textDecoration: 'none', color: 'inherit' }}>
          {params.value}
        </a>
      ),
    },
  ];

  return (
    <Box
      height="100%"
      width="100%"
    >
        <DataGrid
          sx={{
            ...dataGridStyle,
            "& .super-urgent": {
              color: "red", // Sfondo rosso chiaro
              "&:hover": {
                color: "#C21821", // Sfondo rosso più scuro al passaggio del mouse
              },
            },
            "& .med-urgent": {
              color: "orange", // Sfondo rosso chiaro
              "&:hover": {
                color: "#DA5F1C", // Sfondo rosso più scuro al passaggio del mouse
              },
            },
          }}
          rows={customers}
          loading={!charged}
          columns={columns}
          getRowClassName={(params) =>
            params.row.giorniRimanenti < 15 ? "super-urgent" : params.row.giorniRimanenti < 30 ? 'med-urgent' : ''
          }
        />
    </Box>
  );
};

export default LicenseExpT;
